import axios from "axios";
import Api from "../../config/api/axios.urlcontext.js"

export default class recursosMunicipios{
    async getParticipacionesFederalesMunicipiosUno(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getParticipacionesFederalesMunicipiosDos(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getAportacionesFederalesMunicipios(url){
        try {
          const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getParticipacionesAportacionesMunicipios20012012(url){
        try {
          const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getProyectosDesarrolloRegional(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getFORTALECE(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data        
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getFondoParaFronteras(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
    async getFORTASEG(url){
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res.data 
        } catch (error) {
            console.log('error servicio')
            console.error(error.message);
        }
    }
}